import { createFileRoute } from '@tanstack/react-router'

import { AcceptInvitePage } from '@/features/auth'

export const Route = createFileRoute('/_auth/accept-invite')({
  component: AcceptInvitePage
})
